import { z } from 'zod';
export const uuidSchema = z.uuid();
export const isoDateTimeSchema = z.iso.datetime({ offset: true });
/** Calendar date `YYYY-MM-DD` (no time zone). */
export const isoDateSchema = z.iso.date();
export const LOCALES = ['EN', 'HY', 'RU'];
export const localeSchema = z.enum(LOCALES);
function isTimeZone(value) {
    try {
        new Intl.DateTimeFormat('en-US', { timeZone: value });
        return true;
    }
    catch {
        return false;
    }
}
/** IANA time zone identifier, e.g. `Asia/Yerevan`. */
export const timeZoneSchema = z
    .string()
    .min(1)
    .max(64)
    .refine(isTimeZone, { message: 'Unknown time zone' });
export const emailSchema = z
    .string()
    .trim()
    .toLowerCase()
    .max(320)
    .pipe(z.email({ message: 'Enter a valid email address' }));
export const displayNameSchema = z.string().trim().min(1).max(200);
/** Optimistic-concurrency token echoed back on every edit of a versioned record. */
export const versionSchema = z.number().int().min(1);
/** Mandatory justification for sensitive changes; stored in the audit trail. */
export const reasonSchema = z.string().trim().min(3).max(2000);
export const optionalTextSchema = (max) => z.string().trim().max(max).nullable().optional();
//# sourceMappingURL=primitives.js.map